(() => {
  // Treat these classes/attrs as "selected"
  function isSelected(el) {
    if (!el) return false;
    return (
      el.classList.contains('swatch--active') ||
      el.classList.contains('is-selected') ||
      el.classList.contains('selected') ||
      el.getAttribute('aria-checked') === 'true' ||
      el.getAttribute('aria-selected') === 'true'
    );
  }

  // Identify a swatch element reliably across Booster templates
  function findSwatchTarget(node) {
    if (!node) return null;
    return node.closest(
      [
        // Booster-ish swatch elements:
        '.swatch',
        '.swatch--color',
        '.swatch--text',
        '[data-swatch-option]',
        '[data-swatch-value]',
        '[data-swatch-index]'
      ].join(',')
    );
  }

  // Block "toggle off" at the source: clicking the currently selected swatch does nothing.
  function blockIfSelected(e) {
    const sw = findSwatchTarget(e.target);
    if (!sw) return;

    // Only block if it is already selected
    if (isSelected(sw)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  // Capture phase so we beat Booster's handlers
  document.addEventListener('click', blockIfSelected, true);

  // Also block keyboard activation (space/enter) on the selected swatch
  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      blockIfSelected(e);
    },
    true
  );
})();
